import { useMemo } from "react";

interface TransferLimits {
  [transactionType: string]: {
    [key: string]: any;
    amount_available?: number;
  };
}

interface ProcessedLimits {
  limitsForDisplay: {
    [transactionType: string]: {
      [days: string]: any;
    };
  };
  immediateLimitsByTransactionType: {
    [transactionType: string]: number;
  };
}

const excludedTypes: readonly string[] = [
  "immediate_rdc",
  "wire",
  "organization_user_wire",
] as const;

/**
 * Custom hook to process transfer limits data
 * Separates ACH-related limits into display and validation data
 *
 * @param limits - Raw limits data from API
 * @returns Object containing limitsForDisplay and immediateLimitsByTransactionType
 */
const useTransferLimits = (limits: TransferLimits): ProcessedLimits =>
  useMemo(() => {
    const immediate: { [transactionType: string]: number } = {};
    const display: { [transactionType: string]: { [days: string]: any } } = {};

    Object.keys(limits).forEach((transactionType) => {
      if (excludedTypes.includes(transactionType)) {
        return;
      }

      display[transactionType] = {};

      Object.keys(limits[transactionType]).forEach((key) => {
        if (Number(key)) {
          display[transactionType][key] = limits[transactionType][key];
        } else {
          immediate[transactionType] = limits[transactionType][key];
        }
      });
    });

    return {
      limitsForDisplay: display,
      immediateLimitsByTransactionType: immediate,
    };
  }, [limits]);

export default useTransferLimits;
